import React from "react";
import "./OutOfHomeProcess.css";
import { useTranslation } from "react-i18next";
import {
  FaPaperPlane,
  FaFileInvoiceDollar,
  FaFileSignature,
  FaBroadcastTower,
} from "react-icons/fa";

const ICONS = [FaPaperPlane, FaFileInvoiceDollar, FaFileSignature, FaBroadcastTower];

const OutOfHomeProcess = () => {
  const { t } = useTranslation();
  const steps = t("outOfHomePage.process.steps", { returnObjects: true });

  return (
    <div className="oohs-section oohs-section--spacious">
      <div className="oohs-section-inner">
        <h2 className="oohs-title">{t("outOfHomePage.process.title")}</h2>

        <div className="ooh-process-track">
          {steps.map((step, index) => {
            const Icon = ICONS[index];
            return (
              <div key={index} className="ooh-process-step">
                <div className="ooh-process-icon">
                  <Icon size={22} />
                </div>
                <div className="ooh-process-num">
                  {t("outOfHomePage.process.stepLabel", { num: index + 1 })}
                </div>
                <h3 className="ooh-process-title">{step.title}</h3>
                <p className="ooh-process-text">{step.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OutOfHomeProcess;
